import { createContext, useContext } from 'react'
import type { LayoutSettings } from './settings'

/**
 * Context + hook tách riêng khỏi file Provider: file này không export component nên
 * Vite Fast Refresh không tạo lại context khi sửa Provider — nếu để chung, HMR làm
 * Provider (bản cũ) và consumer (bản mới) giữ hai context khác nhau, gây lỗi
 * "useLayoutSettings must be used inside LayoutSettingsProvider".
 */
export type LayoutSettingsContextValue = {
  settings: LayoutSettings
  setSetting: <K extends keyof LayoutSettings>(key: K, value: LayoutSettings[K]) => void
  reset: () => void
}

export const LayoutSettingsContext = createContext<LayoutSettingsContextValue | undefined>(
  undefined
)

export const useLayoutSettings = () => {
  const context = useContext(LayoutSettingsContext)
  if (!context) throw new Error('useLayoutSettings must be used inside LayoutSettingsProvider')
  return context
}
